import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import {saveAs} from "file-saver";
import axios from "axios";
import {ChartTemplate} from "./chartTemplate";

const downloadChartFunc = (divRef, ndx) => { // declare dimension
    const project_description = ndx.dimension((d) => d.baseTbCode);
    // initialize the chart  function
    var table = dc.dataTable(divRef).dimension(project_description).group((d) => {
        return "";
    }).size(5).columns([{ // Specify a custom format for column 'Description' by using a label with a function.
            label: "",
            format: function (d) {
                return d.description;
            }
        },]).order(d3.ascending).on("renderlet", function (table) {
        table.selectAll(".dc-table-group").classed("info", true);
    });

    // Utility  function -  to create a new promise thread
    // wait for UI  and test whether the element we are interested in has been 
    // rendered 
    const getElementByIdAsync = id => new Promise(resolve => {
        const getElement = () => {
            const element = document.getElementById(id);
            if (element) {
                resolve(element);
            } else {
                requestAnimationFrame(getElement);
            }
        };
        getElement();
    });
    const handleSend = async (data) => {

        // get the filtered data
        var data = project_description.top(Infinity);
        // format the data to csv
        var blob = new Blob([d3.csvFormat(data)], { type: "text/csv;charset=utf-8" });

        // create a new form data and append the blob
        const formData = new FormData();

        formData.append("data.csv", blob);



        // test async
        async function getEl() {
           
            const divElement = await getElementByIdAsync('send_indicators');
            if (divElement) {
                
                d3.select("#send_indicators").on("click", function (d) {
                   
                    axios.post("https://kim-ims.azurewebsites.net/Email/SendEmail", formData).then((res) => {
                        alert("Your request has been sent, Pending review")
                        window.MSELECTCOUNTY = undefined
                        window.MVALUECHAIN = undefined
                        window.MSSELECROPTYPE = undefined
                    })
                });
            }
        }
        getEl()
    };

    
    d3.select("#indicators").on("click", function () {
       
        if (typeof window.MSELECTCOUNTY === 'undefined') {
            // alert the user to  make a selection
            // do nothing 
            //console.log("location not selected")

        } else if (typeof window.MVALUECHAIN === 'undefined') {
             // do nothing 

        } else if (typeof window.MSSELECROPTYPE === 'undefined') {

            // do nothing 
        } else {
            handleSend()
        }
    });

    return table;
};

export const DownloadChrt = (props) => (
    <ChartTemplate chartFunction={downloadChartFunc}
        title="Description of Value Chain’s Sub-Category"
        // name="Select Administration Level"
    />
);
